document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.getElementById("StickyATC");
  if (!sticky) return;

  const productForm = document.querySelector("[data-product-form]");
  const originalATC = document.querySelector("[data-product-atc]");
  const originalQty = document.querySelector("[data-quantity-input]");
  const stickyQty = document.getElementById("StickyATCQty");
  const stickyBtn = document.getElementById("StickyATCButton");
  const qtyMinus = sticky.querySelector(".sticky-atc__qty-minus");
  const qtyPlus = sticky.querySelector(".sticky-atc__qty-plus");

  const stickyImageWrap = sticky.querySelector(".sticky-atc__image");
  const stickyVariantEl = document.getElementById("StickyATCVariant");
  const stickyPriceEl = document.getElementById("StickyATCPrice");
  const stickyCompareEl = document.getElementById("StickyATCCompare");
  const stickyPriceWrap = stickyPriceEl ? stickyPriceEl.closest(".sticky-atc__price") : null;
  const stickyBtnText = stickyBtn ? stickyBtn.querySelector(".sticky-atc__button-text") : null;

  if (!productForm || !originalATC) return;

  /* -----------------------
     Product / variant data
  ----------------------- */
  let productData = null;
  try {
    const script = document.getElementById("StickyATCProduct");
    productData = script ? JSON.parse(script.textContent) : null;
  } catch (e) {
    productData = null;
  }

  const formatMoney = (cents) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
      }
    } catch (e) {
      /* fall through to basic formatting */
    }
    return "$" + (cents / 100).toFixed(2);
  };

  const findVariantId = () => {
    // Standard Shopify hidden input
    const idInput = productForm.querySelector('input[name="id"], select[name="id"]');
    if (idInput && idInput.value) return idInput.value.toString();

    // Fallback: read from URL query string if theme updates it
    const params = new URLSearchParams(window.location.search);
    if (params.get("variant")) return params.get("variant");

    return null;
  };

  const updateStickyFromVariant = (variant) => {
    if (!variant) return;

    // Image
    if (stickyImageWrap && variant.featured_image) {
      const src = variant.featured_image.src || variant.featured_image;
      const url = typeof src === "string" ? src.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x$1$2") : src;
      let img = stickyImageWrap.querySelector("img");
      if (!img) {
        img = document.createElement("img");
        img.id = "StickyATCImage";
        img.loading = "lazy";
        img.width = 60;
        img.height = 60;
        stickyImageWrap.innerHTML = "";
        stickyImageWrap.appendChild(img);
      }
      img.src = url;
      img.alt = variant.public_title || productData?.title || "";
    }

    // Variant label (only if more than one variant)
    if (stickyVariantEl) {
      if (productData && productData.variants && productData.variants.length > 1) {
        stickyVariantEl.textContent = "· " + variant.title;
        stickyVariantEl.style.display = "";
      } else {
        stickyVariantEl.style.display = "none";
      }
    }

    // Price
    if (stickyPriceEl) {
      stickyPriceEl.textContent = formatMoney(variant.price);
    }

    if (stickyCompareEl && stickyPriceWrap) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!stickyCompareEl.isConnected) stickyPriceWrap.appendChild(stickyCompareEl);
        stickyCompareEl.textContent = formatMoney(variant.compare_at_price);
        stickyCompareEl.style.display = "";
      } else {
        stickyCompareEl.style.display = "none";
      }
    }

    // Availability
    if (stickyBtn) {
      const available = variant.available !== false;
      stickyBtn.disabled = !available;
      if (stickyBtnText) {
        stickyBtnText.textContent = available ? "Add to cart" : "Sold out";
      }
    }

    sticky.dataset.variantId = variant.id;
  };

  const getVariantById = (id) => {
    if (!productData || !productData.variants || !id) return null;
    return productData.variants.find((v) => v.id.toString() === id.toString()) || null;
  };

  const handleVariantChange = (variant) => {
    if (variant) {
      updateStickyFromVariant(variant);
      return;
    }
    const id = findVariantId();
    const found = getVariantById(id);
    if (found) updateStickyFromVariant(found);
  };

  // 1) Listen for common theme-dispatched variant change events
  [
    "variant:change",
    "variant:changed",
    "product:variant-change",
    "product:variant-changed",
    "onVariantChange",
  ].forEach((eventName) => {
    document.addEventListener(eventName, (e) => {
      const variant = e.detail?.variant || e.detail?.currentVariant || null;
      handleVariantChange(variant);
    });
    productForm.addEventListener(eventName, (e) => {
      const variant = e.detail?.variant || e.detail?.currentVariant || null;
      handleVariantChange(variant);
    });
  });

  // 2) Listen for native change events bubbling from radio/select swatches
  productForm.addEventListener("change", () => {
    // Give the theme's own JS a tick to update its hidden id input first
    setTimeout(() => handleVariantChange(null), 50);
  });

  // 3) Polling fallback in case the theme updates variant via JS property
  //    without firing any event (covers custom swatch/button pickers)
  let lastKnownVariantId = findVariantId();
  setInterval(() => {
    const currentId = findVariantId();
    if (currentId && currentId !== lastKnownVariantId) {
      lastKnownVariantId = currentId;
      handleVariantChange(null);
    }
  }, 300);

  /* -----------------------
     Show / Hide
  ----------------------- */
  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      sticky.classList.toggle("is-visible", !entry.isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(originalATC);

  /* -----------------------
     Quantity Sync
  ----------------------- */
  const syncFromOriginal = () => {
    if (stickyQty && originalQty) {
      stickyQty.value = originalQty.value || 1;
    }
  };

  syncFromOriginal();

  if (stickyQty && originalQty) {
    stickyQty.addEventListener("change", () => {
      const value = Math.max(1, parseInt(stickyQty.value, 10) || 1);
      stickyQty.value = value;
      originalQty.value = value;
      originalQty.dispatchEvent(new Event("change", { bubbles: true }));
    });

    originalQty.addEventListener("change", syncFromOriginal);
  }

  /* -----------------------
     Plus / Minus
  ----------------------- */
  qtyPlus?.addEventListener("click", () => {
    stickyQty.stepUp();
    stickyQty.dispatchEvent(new Event("change"));
  });

  qtyMinus?.addEventListener("click", () => {
    if (parseInt(stickyQty.value, 10) <= 1) return;
    stickyQty.stepDown();
    stickyQty.dispatchEvent(new Event("change"));
  });

  /* -----------------------
     Add To Cart
  ----------------------- */
  stickyBtn?.addEventListener("click", () => {
    if (stickyBtn.disabled || stickyBtn.classList.contains("is-loading")) return;

    if (originalQty) {
      originalQty.value = stickyQty.value;
      originalQty.dispatchEvent(new Event("change", { bubbles: true }));
    }

    stickyBtn.classList.add("is-loading");

    originalATC.click();

    const finish = () => {
      stickyBtn.classList.remove("is-loading");
      stickyBtn.classList.add("is-added");
      const label = stickyBtn.querySelector(".sticky-atc__button-text");
      const originalText = label ? label.textContent : "";
      if (label) label.textContent = "Added ✓";

      setTimeout(() => {
        stickyBtn.classList.remove("is-added");
        if (label) label.textContent = originalText;
      }, 1400);
    };

    if (typeof document.addEventListener === "function") {
      document.addEventListener("cart:updated", finish, { once: true });
      setTimeout(finish, 1200);
    } else {
      setTimeout(finish, 900);
    }
  });
});